import gql from 'graphql-tag';

export const assignCompanyRole = gql`
  mutation assignCompanyRole(
    $userIds: [UUID!]!
    $roleTemplateIds: [UUID!]!
    $channelId: UUID!
  ) {
    assignCompanyRole(
      userIds: $userIds
      roleTemplateIds: $roleTemplateIds
      channelId: $channelId
    ) {
      userId
      success
      skippedCompanyIds
    }
  }
`;

